module.exports = __webpack_public_path__ + "img/banner2.3e19d1d6.jpg";